import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-dialog-item-size',
    templateUrl: './dialog-item-size.component.html',
    styleUrls: ['./dialog-item-size.component.scss']
})
export class DialogItemSizeComponent implements OnInit {

    constructor(public dialogRef: MatDialogRef<DialogItemSizeComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any) {
    }

    ngOnInit() {
        if (!this.data.itemSize) { this.data.itemSize = 20; }
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

    getList(): Array<number> {
        const list: Array<number> = [];
        for (let index = 20; index >= 14; index = index - 0.5) {
            list.push(index);
        }
        return list;
    }
}
